export default "__VITE_ASSET__D08k8vSL__"